var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"d":"M4.5 32H61","key":0}),React.createElement("path",{"strokeLinecap":"square","d":"M27 55L4 32 27 9","key":1})]));
}

ArrowLeftInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
